import eventMapping from 'generated/event_tracker_mapping.json';

export const getSnowplowSchema = (eventName: string): string => {
  return (
    eventMapping.event_tracker_mapping.find(eventMapping => eventMapping.event_name === eventName)
      ?.snowplow_event_name ?? ''
  );
};
